import { filterEmpty } from "../_util/props-util";

import "./style/index.scss";

export default {
  inheritAttrs: false,
  name: "WFormError",
  __WF_: true,
  data() {
    return {
      prefixCls: "wf-form-error"
    };
  },
  render() {
    const { $slots, prefixCls } = this;
    let children = filterEmpty($slots.default);
    return <div class={prefixCls}>{children}</div>;
  }
};
